import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './cvcHint.html' with { type: 'html' };

export default {
	name: 'CCvcHint',
	components: {
		cSvg
	},
	props: {
		hasNote: {
			type: Boolean,
			default: false
		},
		height: {
			type: Number,
			default: 15
		},
		payment: {
			type: Object,
			default: () => {}
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		width: {
			type: Number,
			default: 15
		}
	},
	computed: {
		has4digitCvc() {
			// Amex cards has 4-digit long CVC code
			const amex = ['amex', 'american-express', 'americanexpress'];
			return this.selectedPayment && amex.includes(this.selectedPayment.cardBrand) || this.payment && amex.includes(this.payment.slug);
		}
	},
	template
};
